import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { useApiDeprecated } from "../../context";
import type { Slot } from "./definitions";

export type UseNearestSlotParams = {
  clinic_branch?: number;
  doctor?: number;
  service?: number;
  /**
   * From date (%Y-%m-%d) default Now
   */
  date_from?: string;
};

export type NearestSlotResponse = Slot;

type UseNearestSlotQueryOptions = UseQueryOptions<NearestSlotResponse, Error>;

export const useV1NearestSlot = (
  params: UseNearestSlotParams,
  options?: Partial<UseNearestSlotQueryOptions>,
) => {
  const url = `/api/v1/slots/nearest/`;
  const { api } = useApiDeprecated();

  return useQuery({
    ...options,
    queryKey: [url, params],
    queryFn: () => {
      return api<Slot>(
        {
          url,
          method: "GET",
          params,
        },
        {
          200: async (r) => r.data,
        },
      );
    },
  });
};
